var map = {
	"./DSC_0326.jpg": 8763,
	"./IMG_0470-min.JPG": 268,
	"./IMG_7465-min.png": 7292,
	"./IMG_8506-min.png": 6598,
	"./a_round0.jpg": 2157,
	"./a_round1.png": 8484,
	"./a_round2.png": 9327,
	"./a_round3.png": 310,
	"./a_round4.png": 3353,
	"./a_round5.JPG": 7243,
	"./a_round6.jpg": 6067,
	"./a_round7.JPG": 7897,
	"./a_round8.JPG": 8386,
	"./leaf0-min.png": 7362,
	"./prints0-min.png": 9006,
	"./prints1-min.png": 3935,
	"./prints3.jpg": 18
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6362;